<template>
    <v-card class="panelBlock super-administrator">
        <v-flex tag="h2">{{Administration.SUPER_ADMIN_OPTIONS}}</v-flex>
        <v-flex class="super-administrator__row"
                data-qe-id="group_requested-groups_link"
                @click="requestedGroups()">
            <v-flex class="super-administrator__details">
                <i class="fas fa-users-cog"></i> {{Administration.NEW_GROUP_REQUESTS}}
            </v-flex>
        </v-flex>
    </v-card>
</template>

<script>
    import { mapMutations } from "vuex";
    import { storeMutation } from "../../../store/storeMutations.constant";
    import { Administration } from '../../NetworkPage/NetworkConstants';

    export default {
        name: 'GroupSuperAdminOptions',
        data: () => ({
            Administration,
        }),
        methods: {
            ...mapMutations({
                toggleConfigureGroup: `network/${storeMutation.toggleConfigureGroup}`,
                toggleRequestedGroups: `network/${storeMutation.toggleRequestedGroups}`,
            }),
            requestedGroups() {
                this.toggleConfigureGroup(false);
                setTimeout(() => {
                    this.toggleRequestedGroups(true);
                }, 0);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../../common/styles/_colors.scss";

    .super-administrator {
        &__row {
            position: relative;
            color: $ypo_blue;
            margin: 0;
            align-items: center;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
                background: rgba($ypo-tile-border, 0.3);
                font-weight: 600;
            }
        }

        &__details {
            border-bottom: 1px solid rgba($ypo-tile-border, 0.3);
            margin: 0 15px;
            padding: 15px 0;

            i {
                font-size: 20px;
                margin-right: 5px;
            }
        }
    }
</style>
